export default __webpack_public_path__ + "static/corners-do-ec615fef0e36771ec41851b199f16e04e530416c55785e6770961a333f24d358.png";